/* eslint-disable */
import { produce } from "immer";
import {
  CONTRIBUTION_RATES_FETCH_START,
  CONTRIBUTION_RATES_FETCH_SUCCESS,
  CONTRIBUTION_RATES_FETCH_FAILURE,
} from "../actions/types";

const contributionRates = (
  state = {
    fetching: false,
    data: [],
    error: null,
  },
  action,
) => {
  switch (action.type) {
    case CONTRIBUTION_RATES_FETCH_START:
      return produce(state, (draft) => {
        draft.fetching = true;
      });
    case CONTRIBUTION_RATES_FETCH_SUCCESS:
      return produce(state, (draft) => {
        draft.fetching = true;
        draft.data = action.data;
        draft.fetching = false;
      });
    case CONTRIBUTION_RATES_FETCH_FAILURE:
      return produce(state, (draft) => {
        draft.fetching = false;
        draft.error = action.error;
      });
    default:
      return state;
  }
};

export default contributionRates;
